var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.entry)?_c('div',[_c('v-card',{staticClass:"fill-height"},[_c('v-card-title',[_c('h3',{staticClass:"font-weight-bold primary--text"},[_vm._v(_vm._s(_vm.$t(_vm.entry.name)))])]),_c('v-card-text',{staticClass:"fill-height"},[_vm._v(" "+_vm._s(_vm.$t(_vm.metadata.description))+" ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }